import { Directive, forwardRef, OnChanges, SimpleChanges, Type, input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormControl } from '@angular/forms';
import { MarketType } from '../../domain/market.domain';
import { AutoSuggestSymbol } from '../../domain/symbol-lookup.domain';
import { SymbolLookupComponent } from './symbol-lookup.component';

@Directive({
  selector: '[tdWbSymbolLookupValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<SymbolLookupValidatorDirective> => SymbolLookupValidatorDirective),
    multi: true
  }]
})
export class SymbolLookupValidatorDirective implements Validator, OnChanges {
  readonly symbol = input<SymbolLookupComponent<AutoSuggestSymbol>>(undefined, { alias: 'tdWbSymbolLookupValidator' });
  private onChange: () => void;

  validate(formControl: FormControl): ValidationErrors | null {

    const symbol = this.symbol();
    const shouldValidate = symbol.checkSymbol() || (symbol.fractionalSymbolSearch() && !symbol.focusOnInput());
    if (shouldValidate &&
      !this.isValid(formControl.value, symbol.symbolInput(), symbol.market())) {
      return { invalid : true };
    }
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes !== undefined && this.onChange !== undefined) {
      this.onChange();
    }
  }

  private isValid(enteredSymbol: AutoSuggestSymbol, enteredSymbolInput: string, market: MarketType): boolean {
    if ((enteredSymbolInput !== null && enteredSymbolInput !== '' && enteredSymbolInput !== undefined) &&
      (enteredSymbol === null || enteredSymbol === undefined)) {
      return false;
    }
    if (enteredSymbol !== null && enteredSymbol !== undefined && market !== undefined) {
      return enteredSymbol.market === market;
    }
    return true;
  }
}
